import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, CircleUser, CreditCard, LogOut, ShieldCheck, UserCog, Users } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useAuth } from "@/context/AuthContext";
import { useServices } from "@/context/ServicesContext";
import { AccountDialog } from "@/components/app/AccountDialog";

export const AccountMenu = () => {
  const { user, logout } = useAuth();
  const { openCompany, openTeam, openBilling } = useServices();
  const navigate = useNavigate();
  const owner = user?.tenant_role === "owner";
  const [accountOpen, setAccountOpen] = useState(false);

  return (
    <>
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button size="icon" variant="ghost" className="rounded-full text-slate-300" data-testid="account-menu-button" aria-label="Menu da conta">
          <CircleUser className="h-5 w-5" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 border-slate-700 bg-slate-900">
        <DropdownMenuLabel className="font-normal">
          <div className="truncate text-sm font-semibold" data-testid="account-name">{user?.name || user?.email}</div>
          <div className="truncate text-xs text-slate-400">{user?.email}</div>
          <div className="mt-1 text-[11px] uppercase tracking-wider text-slate-500">{owner ? "Responsável" : "Usuário"} · {user?.company_name}</div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {owner && <DropdownMenuItem onSelect={openCompany} data-testid="menu-company"><Building2 className="mr-2 h-4 w-4" /> Dados da empresa</DropdownMenuItem>}
        {owner && <DropdownMenuItem onSelect={openTeam} data-testid="menu-team"><Users className="mr-2 h-4 w-4" /> Equipe</DropdownMenuItem>}
        {owner && !user?.billing?.exempt && <DropdownMenuItem onSelect={openBilling} data-testid="menu-billing"><CreditCard className="mr-2 h-4 w-4" /> Assinatura</DropdownMenuItem>}
        {user?.platform_role && (
          <DropdownMenuItem onSelect={() => navigate("/painel")} data-testid="menu-platform"><ShieldCheck className="mr-2 h-4 w-4" /> Painel do dono</DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem onSelect={() => setAccountOpen(true)} data-testid="menu-account"><UserCog className="mr-2 h-4 w-4" /> Minha conta</DropdownMenuItem>
        <DropdownMenuItem onSelect={logout} data-testid="logout-button"><LogOut className="mr-2 h-4 w-4" /> Sair</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
    <AccountDialog open={accountOpen} onClose={() => setAccountOpen(false)} />
    </>
  );
};
